var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"keyword_nav_container pt-2",staticStyle:{"height":"50px"}},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',[_c('a',{staticClass:"nav-link",class:_vm.currentPage == 'detail' ? 'active' : '',on:{"click":function($event){return _vm.setTab('detail')}}},[_vm._v("Details")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }